import { Record } from 'immutable'

export class SalesType extends Record({
    id: undefined,
    name: undefined,
}) {}
